import React from 'react';
import { CollapseContentProps } from '../types';

export const CollapseContent = ({ children }: CollapseContentProps): JSX.Element => {
  return <>{children}</>;
};
